/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Box, styled } from "@mui/system";

export const StyledBox = styled(Box)({
  display: "flex",
  gap: "10px",
  justifyContent: "flex-end",
  flexDirection: "row",
  marginBottom: "10px",
});
